import { PaymentMethodType } from '@/lib/api/billing';

/**
 * The three payment-method options shown in the dialog selector, and how they
 * collapse onto the two values the billing API accepts. Credit and Debit are
 * both `card` on the wire — the distinction is UI-only (Credit shows a
 * processing-fee note) and does NOT trigger a session refetch.
 */
export type PaymentMethodUiType = 'bank' | 'credit' | 'debit';

const UI_TO_API: Record<PaymentMethodUiType, PaymentMethodType> = {
  bank: 'ach',
  credit: 'card',
  debit: 'card',
};

export const toApiPaymentMethodType = (ui: PaymentMethodUiType): PaymentMethodType => UI_TO_API[ui];
